import { theme } from '@aloft/toolkit-sui';

import { COMP_PIN_PATH } from './compPinPath.ts';

const HOME_PATH =
  'M13.8337 14.4347C13.8337 14.5846 13.7766 14.7283 13.675 14.8343C13.5734 14.9403 13.4357 14.9999 13.292 14.9999H5.70866C5.565 14.9999 5.42723 14.9403 5.32564 14.8343C5.22406 14.7283 5.16699 14.5846 5.16699 14.4347V9.34771H3.54199L9.13578 4.04145C9.23551 3.94676 9.36549 3.89429 9.50033 3.89429C9.63516 3.89429 9.76514 3.94676 9.86487 4.04145L15.4587 9.34771H13.8337V14.4347ZM12.7503 13.8694V8.30601L9.50033 5.22332L6.25033 8.30601V13.8694H12.7503ZM9.50033 12.739L7.68087 10.8404C7.5677 10.7224 7.47792 10.5822 7.41667 10.4279C7.35543 10.2736 7.3239 10.1082 7.3239 9.94118C7.3239 9.77418 7.35543 9.6088 7.41667 9.45451C7.47792 9.30021 7.5677 9.16002 7.68087 9.04192C7.79404 8.92383 7.92839 8.83015 8.07626 8.76624C8.22413 8.70233 8.38261 8.66944 8.54266 8.66944C8.70271 8.66944 8.86119 8.70233 9.00906 8.76624C9.15692 8.83015 9.29128 8.92383 9.40445 9.04192L9.50033 9.14197L9.5962 9.04192C9.70937 8.92383 9.84373 8.83015 9.99159 8.76624C10.1395 8.70233 10.2979 8.66944 10.458 8.66944C10.618 8.66944 10.7765 8.70233 10.9244 8.76624C11.0723 8.83015 11.2066 8.92383 11.3198 9.04192C11.433 9.16002 11.5227 9.30021 11.584 9.45451C11.6452 9.6088 11.6767 9.77418 11.6767 9.94118C11.6767 10.1082 11.6452 10.2736 11.584 10.4279C11.5227 10.5822 11.433 10.7224 11.3198 10.8404L9.50033 12.739Z';

export const SubjectPinIcon = () => (
  <svg
    width="19"
    height="24"
    viewBox="0 0 19 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block', flexShrink: 0 }}
  >
    <path d={COMP_PIN_PATH} fill={theme.colors.textWarning} stroke="white" />
    <path d={HOME_PATH} fill="white" />
  </svg>
);
